// extracted by mini-css-extract-plugin
export default {"callToActionButtonWrapper":"ButtonCallToAction_callToActionButtonWrapper__8KnzW","callToActionButton":"ButtonCallToAction_callToActionButton__qBvxi"};